import(/* webpackMode: "eager" */ "/home/ubuntu/download/69adf962886e100014516e79/autobodyshop/src/app/services/module-coding/page.tsx");
